import routeUtil from '../utils/route.util'
import { ReportPaginateResponseData } from '../utils/reportPaginate.util'
import api, {
  PaginateRequest, PaginateResponse, ResponseCallback
} from '../services/api.service'
import { PalletData } from './pallet.api'
import { ShipOrderData } from './shipOrder.api'
import { UserData } from './user.api'

export interface ShipData {
  id: number
  siteId: number
  shipOrderId: number
  palletId: number
  createdBy: number
  deletedBy?: number
  quantity: number
  createdAt: string
  deletedAt?: string
  isDeleted: boolean
  createdUser?: UserData
  order?: ShipOrderData
  pallet?: PalletData
}

export interface ShipShippedStatusResponse {
  daily: {
    quantity: number
    average: number
  }
  weekly: {
    quantity: number
    average: number
  }
  monthly: {
    quantity: number
    average: number
  }
}

export interface ShipCreateRequest {
  shipOrder?: number
  pallet?: number
  latitude?: number
  longitude?: number
}

export interface ShippingReportExportRequest {
  startAt?: string
  endAt?: string
  item?: number
  customer?: number
  lpn?: string
}

export interface ShippingReportPaginateRequest
  extends ShippingReportExportRequest, PaginateRequest {}

type ShippingReportPaginateResponse = PaginateResponse<ReportPaginateResponseData[]>

const routes = {
  shippedStatus: '/ships/shipped/status',
  create: '/ships',
  delete: '/ships/{id}',
  paginateReport: '/ships/report/paginate',
  exportReport: '/ships/report/export'
}

export default {
  shippedStatus (callback: ResponseCallback<ShipShippedStatusResponse>) {
    api.get(routes.shippedStatus, {}, callback)
  },

  create (payload: ShipCreateRequest, callback: ResponseCallback<ShipData>) {
    api.post(routes.create, payload, callback)
  },

  delete (id: number, callback: ResponseCallback<ShipData>) {
    const url = routeUtil.replaceParams(routes.delete, { id })
    api.delete(url, {}, callback)
  },

  paginateReport (
    payload: ShippingReportPaginateRequest,
    callback: ResponseCallback<ShippingReportPaginateResponse>
  ) {
    api.post(routes.paginateReport, payload, callback)
  },

  exportReport (
    payload: ShippingReportExportRequest,
    callback: ResponseCallback<Blob>
  ) {
    api.post(routes.exportReport, payload, callback)
  }
}
